<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" sm="4" lg="3" xl="2">
        <div v-if="component.mainImage && component.mainImage.thumbnail">
          <img :src="component.mainImage.thumbnail.url">
        </div>
        <div v-else-if="component.mainImage">
          <img :src="component.mainImage.url">
        </div>
      </b-col>
      <b-col cols="12" sm="8" lg="9" xl="10">
        <span class="name">
          {{ component.name }}
        </span>
        <br>
        <span class="description">
          {{ component.description }}
        </span>

        <span v-if="component.knowledgecheck_id">
          <br/>
          <a title="view knowledge checks" @click.stop.prevent="onKnowlegecheckClick">
            <b-badge variant="success">knowledge check</b-badge>
          </a>
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    disabled: {
      type:Boolean,
      default: false
    }
  },
  methods:{
    onKnowlegecheckClick(){
      if(!this.disabled && this.component && this.component.knowledgecheck_id){
        this.$router.push({ name:'client-component-knowledgecheck', params: { component: this.component.id, knowledgecheckId: this.component.knowledgecheck_id } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
@import 'node_modules/bootstrap/scss/bootstrap-grid.scss';

img {
  width: 100%;
  height: auto;
}

@include media-breakpoint-down(xs) {
  img {
    margin-bottom: $spacing-xs;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/components/row.vue